

import __layout_0 from '/workspace/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/workspace/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/workspace/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/workspace/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/workspace/src/layouts/components/Footer.vue'),
'components/NavBarI18n': () => import('/workspace/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/workspace/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/workspace/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/workspace/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/workspace/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/workspace/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
